import { render, staticRenderFns } from "./PageConfigFieldsList.vue?vue&type=template&id=dc32fe44&"
import script from "./PageConfigFieldsList.vue?vue&type=script&lang=js&"
export * from "./PageConfigFieldsList.vue?vue&type=script&lang=js&"
import style0 from "./PageConfigFieldsList.vue?vue&type=style&index=0&id=dc32fe44&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports